module.exports = __webpack_public_path__ + "static/index-oikos-97310a7cfa9de6d69d76f3729a60833d.jpg";